import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, Instagram } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Servicio',
    href: '#servicio'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Preguntas',
    href: '#preguntas'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-black ${isScrolled ? 'py-3 shadow-lg shadow-black/50' : 'py-5'}`} data-id="element-293" data-mp="3fbgn3mv5vgyf">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-294" data-mp="2wiro7mnmkjqh">
        <a href="#inicio" className="relative group" data-id="element-295" data-mp="2rkgdzatf477q">
          <motion.img src="https://cdn.magicpatterns.com/uploads/6U8Zqe8m1fPZcxDL2DDpsS/logorendcelebrate.png" alt="Celebrate Your Party Logo" fetchPriority="high" decoding="async" className="h-20 md:h-28 w-auto object-contain -my-3" style={{
          WebkitMaskImage: 'radial-gradient(circle at center, black 50%, transparent 54%)',
          maskImage: 'radial-gradient(circle at center, black 50%, transparent 54%)'
        }} whileHover={{
          scale: 1.05
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} data-id="element-296" data-mp="2mm54x2ay60qk" />
          <div className="absolute inset-0 bg-gold/30 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-297" data-mp="3tabsha1tt78i"></div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-298" data-mp="1wbmkuwgxp78c">
          <ul className="flex items-center gap-6" data-id="element-299" data-mp="1hnruhmqefeyf">
            {navLinks.map(link => <li key={link.name} data-id="element-300" data-mp="1mmuyd3un7f4t">
                <a href={link.href} className="text-cream/80 hover:text-gold transition-colors text-sm font-medium tracking-wide uppercase" data-id="element-301" data-mp="1mm34bxgp1pgn">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" aria-label="Instagram @celebrateyp" className="text-gold hover:text-gold-light transition-all hover:drop-shadow-[0_0_8px_rgba(212,175,55,0.6)]" data-id="element-302" data-mp="ypp87fp8jw4b">
            <Instagram size={22} data-id="element-303" data-mp="2y0yrk7teoz8t" />
          </a>
          <a href="#reservar" className="flex items-center gap-2 bg-gold hover:bg-gold-light text-ink px-6 py-2.5 rounded-full font-semibold transition-all hover:shadow-[0_0_15px_rgba(212,175,55,0.4)] hover:-translate-y-0.5" data-id="element-304" data-mp="2xznns7zynrhp">
            <Phone size={18} data-id="element-305" data-mp="w59cpfzxhqfy" />
            <span data-id="element-306" data-mp="w6kdr81zok3d">Reserva tu Fecha</span>
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-cream p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-307" data-mp="rbwqfciq1vqd">
          {isMobileMenuOpen ? <X size={28} data-id="element-308" data-mp="1059pyxbajvlf" /> : <Menu size={28} data-id="element-309" data-mp="105t9ujki4u23" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-310" data-mp="1f20u1jvwtvhd">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden absolute top-full left-0 right-0 bg-ink border-t border-charcoal shadow-xl" data-id="element-311" data-mp="1a4ihzkmlj055">
            <ul className="flex flex-col py-4" data-id="element-312" data-mp="27xi46nzkejye">
              {navLinks.map(link => <li key={link.name} data-id="element-313" data-mp="2cwv1k2o2b9f8">
                  <a href={link.href} className="block px-6 py-3 text-cream hover:text-gold hover:bg-charcoal transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-314" data-mp="2cxwekcon25zl">
                    {link.name}
                  </a>
                </li>)}
              <li data-id="element-315" data-mp="1p565qcc182tj">
                <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-6 py-3 text-gold hover:bg-charcoal transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-316" data-mp="1t8vscw95cabx">
                  <Instagram size={18} data-id="element-317" data-mp="15hyo85nlehb8" />
                  <span data-id="element-318" data-mp="15gx29651gaeq">@celebrateyp</span>
                </a>
              </li>
              <li className="px-6 pt-4 pb-2" data-id="element-319" data-mp="xyz5m27ygtsx">
                <a href="#reservar" className="flex items-center justify-center gap-2 bg-gold text-ink px-6 py-3 rounded-full font-semibold w-full" onClick={() => setIsMobileMenuOpen(false)} data-id="element-320" data-mp="t05swc0ht6tt">
                  <Phone size={18} data-id="element-321" data-mp="k23mti1wjnzo" />
                  <span data-id="element-322" data-mp="f1fwyzpetd71">Reserva tu Fecha</span>
                </a>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}